import api from "./apiService";

export async function verifyLeadTicket(token) {
  try {
    const data = await api.get(`/dynamic365/verify-lead-Token?token=${token}`);
    return data;
  } catch (error) {
    console.error("Error in verify lead token", error);
    throw error;
  }
}

export async function createLeadFromToken(
  token,
  full_name,
  subject,
  phone_number,
  email
) {
  try {
    const result = await api.post(`/dynamic365/create-lead-from-token`, {
      full_name: full_name,
      token: token,
      phone_number: phone_number,
      email: email,
      subject: subject,
    });
    return result;
  } catch (error) {
    console.error("error in create lead", error);
    throw error;
  }
}
